import Doars from './DoarsExecute.js'

window.Doars = Doars
